import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface IHorizontalSplitTextSingleFeatureImageProps
	extends IBaseElementProps {
	/**
	 * Image - Recommended Size: 602px x 482px
	 */
	image?: IImage;
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Sub Heading
	 * @control richtext
	 */
	subHeading?: string;
	/**
	 * Description
	 * @control richtext
	 */
	description?: string;
	/**
	 * CTA Button
	 */
	ctaButton?: ILink;
	inverted?: boolean;
}

/**
 * Calian Horizontal Split Text & Single Image Feature Component
 * @icon format-gallery
 * @block
 */
const HorizontalSplitTextSingleFeatureImage: React.FC<IHorizontalSplitTextSingleFeatureImageProps> =
	({
		id,
		className,
		classNames = [],
		image,
		heading,
		subHeading,
		description,
		ctaButton,
		inverted = false,
	}) => (
		<div
			id={id}
			className={
				className ||
				cn(
					'calian-horizontal-split-text-single-feature-image',
					inverted &&
						'calian-horizontal-split-text-single-feature-image--inverted',
					...classNames,
				)
			}
		>
			<div className="calian-horizontal-split-text-single-feature-image__container container-fluid">
				<div className="row">
					<div className="calian-horizontal-split-text-single-feature-image__left col-12 col-lg-6">
						{image && (
							<div className="calian-horizontal-split-text-single-feature-image__image">
								<Image className="img-fluid" {...image} />
							</div>
						)}
					</div>
					<div className="calian-horizontal-split-text-single-feature-image__right col-12 col-lg-6">
						{heading && (
							<h2 className="calian-horizontal-split-text-single-feature-image__heading">
								{heading}
							</h2>
						)}
						{subHeading && subHeading !== '<br>' && (
							<p className="calian-horizontal-split-text-single-feature-image__sub-heading">
								<span
									dangerouslySetInnerHTML={{
										__html: subHeading,
									}}
								/>
							</p>
						)}
						{description && (
							<p
								className="calian-horizontal-split-text-single-feature-image__description"
								dangerouslySetInnerHTML={{
									__html: description,
								}}
							/>
						)}
						{ctaButton?.label && (
							<Button
								className={cn(
									`btn btn-${
										inverted ? 'secondary' : 'primary'
									} calian-horizontal-split-text-single-feature-image__cta-button`,
								)}
								{...ctaButton}
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	);

export default HorizontalSplitTextSingleFeatureImage;
